const Strings = {
  login: {
    log_in_account: 'Login to your account',
    enter_your_login_detail: 'Enter your User ID and Password to login',
    forgot_password: 'Forgot Password?',
    new_user: ' New User?',
    register: ' Register',
    copyright: 'Copyright',
    copyright_company: ', IIFL Samasta Finance Limited. All Right Reserved',
    incorrect_userid: 'Enter valid User ID',
    incorrect_password: 'Incorrect password',
    enter_credentials: 'Enter Credentials',
    password_expire_msg: 'Password Expired!',
    password_expire_sub_msg:
      'Your password has expired. Please create a new one to maintain account security.',
    auth_token: 'auth_token',
    interval_instance: 'interval_instance',
    user_data: 'user_data',
  },
  logout: 'Logout',
  yes_logout: 'Yes, Logout',
  confirm_logout_title: 'Confirm Logout',
  confirm_logout_sub_title: 'Are you sure you want to logout?',

  otp: {
    verify_otp: 'Verify OTP',
    enter_otp:
      'Please enter the OTP which has been sent to the registered mobile number.',
    resend_otp: 'Resend OTP',
    seconds: ' seconds',
    verify: 'Verify',
    verify_successful: 'Verification Successful',
    verified_otp: 'You have verified your OTP',
    exhausted_error:
      'Your OTP attempts are exhausted. Please try after 1 hourrrrr.',
    incorrect_otp: 'Incorrect  OTP',
    verify_title: 'Verify Mobile Number',
    update_mobile_number: 'Update Mobile Number?',
    back_to_login: 'Back To Login ',
  },
  register: {
    register_account: 'Register your account',
    userid_to_proceed: 'Enter your User ID to proceed.',
    continue: 'Continue',
    set_successfully: 'Password Set Successfully',
    password_set: 'Your password has been set ',
    invalid_user_id: 'Enter valid User ID',
    username_exist_msg: 'User already exists',
    error: 'Error',
  },
  reset: {
    reset_password: 'Reset your password',
    set_password: 'Set your password',
    create_strong_password:
      'Create a strong password with letters, numbers and symbols.',
    continue: 'Continue',
    reset_successfully: 'Password Reset Successfully',
    password_reset: 'Your Password has been reset ',
    enter_valid_password_error: 'Please enter a valid password',
    password_donot_match_error: 'Passwords do not match',
    enter_password: 'Please enter a valid Password',
    password_mismatch: 'Passwords do not match',
    password: 'Enter Password',
    confirm_password: 'Confirm Password',
  },
  tooltip: {
    character_restrict: 'Use 8-30 characters.',
    password_tooltip:
      'Include at least one digit, uppercase, lowercase, and special character(!@#$%&* () -+=^).',
    space_restriction: 'No spaces allowed.',
  },
  errorMessage: {
    firstName: 'Enter First Name',
    middleName: 'Enter Middle Name',
    lastName: 'Enter Last Name',
    mobileNumber: 'Enter Mobile Number',
    dob: 'Enter Date of Birth',
    gender: 'Select Gender',
    pinCode: 'Enter Pin Code',
    loanProduct: 'Select Loan Product',
    leadSource: 'Select Lead Source',
    loanPurpose: 'Select Loan Purpose',
    loanAmount: 'Enter Loan Amount',
    loanTenure: 'Enter Loan Tenure',
    productRequired: 'Select Product Required',
    followUpDate: 'Enter Follow Up Date',
  },
  leadManagement: {
    leadDetails: 'Lead Details',
    leadStepSectionInstruction:
      ' Please complete the below steps to create a new lead.',
    contactDetails: 'Contact Details',
    loanDetails: 'Loan Details',
    leadGenerateType: 'add',
    leadViewType: 'view',
    nothingHere:
      ' It looks like there is nothing here yet. Start by creating a new entry to get started.',
    noRecord: ' No Records Found!',
    rejectProvideReason: ' Please provide the reason for rejecting this Lead.',
    rejectLead: 'Reject Lead',
    reject_category: 'Reject Reason',
    reject_name: 'reasonCategory',
    reject_dropdown_header: 'Rejection Reason Category',
    reject_dropdown_subheader: 'Rejection Reason Subcategory',
    create_lead: 'Generate New Lead',
    count_val: 'Leads',
    lead_type: 'Lead',
    lead_reject_button: 'Reject',
    reject_popup_header: 'Lead Rejected!',
    reject_popup_subheader: 'You have successfully rejected the lead.',
    lead_management_header: 'Lead Management',
  },
  platform_management: {
    platform_management: 'Platform Management',
    platform_details: 'Platform Details',
    platform_type: 'Platform',
    platform: 'Platform',
    details: 'Details',
    create_platform: 'Create New Platform',
    count_val: 'Platforms',
    others_details: 'Other Details',
    capture_location: 'Capture Location',
    edit: 'Edit',
    reassign: 'Reassign',
    reassignSuccess: 'Reassign Successful!',
    reassignFailure: 'Failed to Reassign',
    reassignSuccessSub: 'You have reassigned the platform to a new SO.',
    reassignFailureSub: 'There was a problem in reassigning.Please try again.',
    reassignSoDesc:
      'Please select the SO name from the list to whom you want to reassign the platform.',
  },
  mandatory_btn_continue: 'Yes, Continue',
  save_btn_continue: 'Save & Continue',
  next_btn: 'Next',
  continue_btn: 'Continue',
  close_btn: 'Close',
  submit_btn: 'Submit',
  mandatory_btn_submit: 'Yes, Submit',
  mandatory_missing_title: 'Missing Mandatory Fields!',
  mandatory_title_incomplete: 'Application Moved to Incomplete Queue!',
  mandatory_subtitle_pending:
    'Your application will be in a pending state due to missing mandatory fields. Do you want to proceed?',
  mandatory_subtitle_incomplete:
    'Your application will be in a incomplete state due to missing mandatory fields. Do you want to proceed?',
  lead_generation_success: 'Lead Generation Successful',
  platform_creation_success: 'Platform Creation Successful',
  platform_creation_edit_success: 'Platform Updation Successful',

  mcc_creation_success: 'MCC Creation Successful',
  mcc_creation_edit_success: 'MCC Updation Successful',
  congratulation: 'Congratulations!  You have generated a new lead!',
  congratulation_platform: 'Congratulations!  You have created a new platform',
  congratulation_edit_platform: 'You have updated a platform',
  congratulation_mcc: 'Congratulations!  You have created a new MCC',
  congratulation_edit_mcc: 'You have updated a MCC',
  success: 'Success',
  error: 'Error',
  // apiError: 'Oops! Something went wrong. Please try again.',
  fetchExisitingDetails: 'Please fetch exisiting samasta details before proceeding',
  uploadFiles: 'Please upload files before proceeding',
  noPlatform: 'There is no Platform available',
  yesSave: 'Yes, Save',
  saveYourProgress: 'Save Your Progress?',
  areYourSureText: 'Are you sure you want to re-Initiate E-sign again',
  saveProgressMessage:
    'Do you want to save the details you have filled before going back?',
  locationPermissionMessage: 'Allow access to your location',
  locationPermissionSubMessage:
    'Please allow location access to verify your location accurately.',
  allow: 'Allow',
  locateMe: 'Locate Me',
  captureLocation: 'Capture Location',
  fetchingLocation: 'Fetching location....',
  platformLocationInstructions: 'Ensure platform must be within',
  platformLocationInstructTwo:
    'km from the Branch location . Then tap "Capture Location" to create the platform.',
  mccLocationInstructions:
    'Ensure  you are in the correct location. Then tap "Capture Location" to create the MCC.',
  na: 'N/A',
  rupee: '₹',
  applicant: 'Applicant',
  noRecord: ' No Records Found!',
  noRecordDetail: 'It looks like there is nothing here yet.',
  try_again: 'Try Again',
  yesExit: 'Yes, Exit',
  doYouWantToExit: 'Do you want to exit?',
  exitMessage:
    'Are you sure you want to exit? Your current progress will be lost.',
  locationAPIError:
    'Sorry! Cannot capture due to network failure. Please try again.',
  okay: 'Okay',
  outOfRange: 'Out of Range!',
  outOfRangeMessage:
    'Please ensure that platform is within mentioned range to capture the location.',
  cancel: 'Cancel',
  sidebar: {
    dashboard: 'Dashboard',
    lead_management: 'Lead Management',
    loan_application: 'Loan Applications',
    masters: 'Masters',
    logs: 'Logs',
    platform_management: 'Platform Management',
    loan_search: 'Loan Search',
    mcc_management: 'MCC Management',
    help: 'Help',
    logout_account: 'Logout Account',
    configuration: 'Configuration',
    settings: 'SETTINGS',
    camelcase_settings: 'Settings',
    reassignment: 'Reassignment ',
    reports: 'Reports',
  },
  rolesCode: {
    SO: 'RL001',
    BM: 'RL002',
    CO: 'RL003',
  },
  mcc_dashboard: {
    mcc_management: 'MCC Management',
    mcc: 'MCC',
    create_mcc: 'Create New MCC',
    mcc_type: 'Mcc',
    mcc_details: 'MCC Details',
    capture_location: 'Capture Location',
    count_val: 'Records',
  },
  loan_applications: {
    loan_application_header: 'Loan Applications',
    qde: 'QDE',
    dde: 'DDE',
    field_investigation: 'FieldInvestigation',
    customer_id: 'Customer ID',
    application_id: 'Application ID',
    loan_account_number: 'Loan Account Number',
    tab_name: {
      applicant: 'Applicant',
      co_applicant: 'Co-Applicant',
      application_details: 'Application Details',
      validation_summary: 'Validation Summary',
      history: 'History',
    },
    dashboard_type_qde: 'QDE',
    dashboard_type_dde: 'DDE',
    dashboard_type_fi: 'Field Investigation',
    applications: 'Applications',
    reject_application: 'Rejected Application’s',
    dashBoard_type_rejected: 'Rejected',
    application_type_qde: 'QDE',
    application_type_dde: 'DDE',
    application_type_rejected: 'Rejected Applications',
    application_type_fi: 'Field Investigation',
    application_type_review_fi: 'Review & FI',
    dashboard_type_review_fi: 'Review & FI',
    application_type_review_cd: 'Review',
    dashboard_type_review_cd: 'Review',
    dashboard_type_personal_dis: 'Personal Discussion',
    application_type_personal_dis: 'Personal Discussion',
    application_type_onhold: 'On Hold',
    dashboard_type_onhold: 'on_hold',
    application_type_eligibility: 'Eligibility Check & CAM',
    dashboard_type_eligiblity: 'Eligibility Check & CAM',
    application_type_approval_flow: 'Approval Workflow',
    dashboard_type_approval_flow: 'Approval Workflow',
    application_type_loan_booking: 'Loan Booking',
    dashboard_type_loan_booking: 'Loan Booking',
    application_type_doc_esign: 'Document Execution & E-sign',
    dashboard_type_doc_esign: 'Document Execution & E-sign',
    application_type_doc_verify: 'Document Verification',
    dashboard_type_doc_verify: 'Document Verification',
    application_type_part_approval: 'Partner Approval(CLM2)',
    dashboard_type_part_approval: 'partner',
    application_type_disbursement: 'Disbursement',
    dashboard_type_disbursement: 'Disbursement',
    view_bureau_summary: 'View Bureau Summary',
    view_aadhaar_details: 'View Aadhaar Details',
    bureau_report: 'Bureau Report',
    reject_message: 'Application Rejected!',
    reject_sub_message: 'Customer application moved to rejected queue',
    dashboard_type_con: 'Conversation',
    application_type_con_dis: 'Conversation',
    dashboard_type_order_con: 'Order Confirmation',
    application_type_order_con: 'Order Confirmation',
    accordian: {
      kyc: 'KYC Details',
      personal_details: 'Personal Details',
      bureau_report: 'Bureau Report',
      documents: 'Documents',
      PreviousKYCDetails: 'PreviousKYCDetails',
      aadhaar_card: 'Aadhaar Card',
      pan_card: 'PAN Card',
      voter_id: "Voter's Card",
      driving_license: 'Driving License',
      product_selection: 'Product Selection',
      consumer_durable_details: 'Consumer Durable Details',
      obligation: 'Obligation',
      existing_loan_details: 'Existing Samasta Loan Details',
      credit_recommendation: 'Credit Recommendation',
    },
    other_documents: 'Other Documents',
    invalidFormat: 'Invalid Format',
    updateSave: 'Data Updated Successfully',
    EligibilityCheck: 'Eligibility Check',
    borrower_details: 'Borrower (s) Details',
    addProductFilter: 'Add Product Filter',
    addProductFilterSubMessage:
      'Select the product from the dropdown menu. The data will be filtered according to the product.',
  },
  masters: {
    masters: 'Masters',
    bulk_upload: 'Bulk Upload',
    force_logout: 'Force Logout',
    add_new: 'Add New',
    map: 'Map',
    download: 'Download',
    role_master: 'Role Master',
    branch_master: 'Branch Master',
    state_master: 'State Master',
    user_master: 'User Master',
    consumer_durable_master: 'Consumer Durable Master',
    loan_product_master: 'Loan Product Master',
    pincode_master: 'Pincode Master',
    bank_branch_master: 'Bank Branch Master',
    role_reports_master: 'Role & Reports Master',
    branch_product_master: 'Branch to Product Master',
    co_lending_master: 'Co-Lending Master',
    added_record: 'New Record Added!',
    added_record_des: 'A new record has been successfully added to the table.',
    failed_added_record: 'Failed to Add New Record',
    failed_added_record_des:
      'There was a problem in adding the record please try again.',
    updated_record: 'Record Updated! ',
    updated_record_des:
      'the record has been successfully updated to the table.',
    failed_updated_record: 'Failed to Update Record',
    failed_updated_record_des:
      'There was a problem in updating the record please try again.',
    status_change: 'Change Status?',
    status_change_msg:
      'Do you really want to change the status of this record?',
    bulk_upload_success: 'Bulk Upload  Successful!',
    bulk_upload_success_des: 'All 100 records has been successfully uploaded.',
    bulk_upload_failed: 'Bulk Upload  Failed!',
    bulk_upload_failed_des: 'Bulk Upload has failed, Please try again.',
    bulk_upload_partial: 'Partial Upload Done',
    bulk_upload_partial_des:
      '94/100 records have been uploaded successfully. The following 4 records encountered errors during the upload process.',
  },
  loanBookApplications: {
    loan_booking: 'Loan Booking',
    accordian: {
      fee_and_charges: 'Fees & Charges',
      schedule: 'Schedule',
      partner_information: 'Partner Information',
    },
  },
  documentVerification: {
    document_verification: 'Document Verification',
    accordian: {
      bank_detail: 'Bank Account Details',
      document_checklist: 'Document Checklist',
    },
  },
  document_execution: {
    accordian: {
      disbursement_details: 'Disbursement Details',
      loan_documents: 'Loan Documents',
      bank_account_details: 'Bank Account Details',
    },
  },
  cattleDetails: {
    cattleSaveMessage: 'Cattle Details Saved Successfully',
  },
  otherIncomeDetails: {
    otherIncomeSaveMessage: 'Other Income Details Saved Successfully',
  },
  HouseHoldDetails: {
    HouseHoldSaveMessage: 'HouseHold Details Saved Successfully',
  },
  referenceDetails: {
    referenceSaveMessage: 'Reference Details Saved Successfully',
  },
  creation_add_type: 'add',
  creation_edit_type: 'edit',
  creation_view_type: 'view',
  creation_reject_type: 'reject',
  locValue: {
    login_loc: 'LOGIN',
  },
  idleTimeMessage: 'You have been idle for',
  idleTimeMessageTwo: 'minutes. You will be logged out.',
  profile: {
    change_password: 'Change Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    success_password: 'Password Set Successfully!',
    information: 'Information',
    success_sub_password:
      "'Your password has been successfully set. Please login again.'",
    change_pass_subMessage:
      'To enhance your account security. Please choose a strong password.With a mix of letters, numbers, and special characters.',
  },
  loanSearch: {
    loanSearch: 'Loan Search',
    loanSearchDetail: 'Loan Detailed View',
  },
  manageReassignement: {
    manageReassignementHeader: 'Manage Reassignment',
  },
  ApiLog: {
    logs: 'Logs',
    apiLogs: 'API Logs',
    loanAppLogs: 'Loan Application logs',
    loanDetails: 'Details',
    useFilter: 'Use the filters to narrow down your API search.',
    reqResDetail: 'Request & Response Details',
    viewReqResDetail: 'View request response details of the API',
  },
  configuration: {
    config: 'Configuration',
    updateSubHeader: 'Configurations have been updated successfully',
    globalsuccessHeader: 'Global Configurations ',
    apisuccessHeader: 'API Configurations ',
    failSubHeader:
      'There was problem in updating configurations.Please try again.',
    updateFailedHeader: 'Update Failed',
    addFailedHeader: 'Add Failed',
    branchsuccessAddHeader: 'Branch Configurations Added',
    productsuccessAddHeader: 'Product Configurations Added',
    branchsuccessEditHeader: 'Branch Configurations Updated',
    productsuccessEditHeader: 'Product Configurations Updated',
    addSubHeader: 'Configurations have been added successfully',
  },
  labels: {
    fromDate: 'From Date',
    toDate: 'To Date',
    apiName: 'API Name',
    request: 'Request',
    response: 'Response',
  },
  templateEngine: {
    templateEngineDetail: 'Select product and template from the dropdown',
    addVariable: 'Add Variables',
  },
};

export default Strings;
